/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/shopify-development`, controller.web, makeLayout, render);
    router(`/dashboard/shopify-development/edit`, controller.editWeb, makeLayout, render);
    router(`/dashboard/shopify-development/new`, controller.newWeb, makeLayout, render);
    router(`/dashboard/shopify-development/subscribe`, controller.newWeb, makeLayout, render);
};
